// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gkSRx","logo":"styles_logo__Ed+P1","logo-devider":"styles_logo-devider__7CRoP","img":"styles_img__QkGLj","text-block":"styles_text-block__MuadO"};